/** Пары PO number + год с карточки Product List и подпись для Tax. */

export function formatPoLabel(entry) {
  const number = String(entry?.po_number || '').trim()
  const year = Number(entry?.year)
  if (!number || !Number.isInteger(year)) {
    return ''
  }
  return `${number} ${year} год`
}

export function latestPoEntry(entries) {
  let best = null
  for (const entry of entries || []) {
    if (!formatPoLabel(entry)) {
      continue
    }
    if (!best || Number(entry.year) >= Number(best.year)) {
      best = entry
    }
  }
  return best
}

export function normalizePoEntries(raw) {
  if (!Array.isArray(raw)) {
    return []
  }
  return raw
    .map(item => ({
      id: item?.id ? String(item.id) : '',
      po_number: String(item?.po_number || '').trim(),
      year: Number(item?.year),
    }))
    .filter(item => item.id && item.po_number && Number.isInteger(item.year))
}

/**
 * Какая пара PL соответствует уже сохранённому номеру пошлины.
 */
export function matchPoEntry(entries, poNumber, poEntryId) {
  const list = normalizePoEntries(entries)
  if (poEntryId) {
    const byId = list.find(item => item.id === String(poEntryId))
    if (byId) {
      return byId
    }
  }
  const text = String(poNumber || '').trim()
  if (!text) {
    return null
  }
  const byLabel = list.find(item => formatPoLabel(item) === text)
  if (byLabel) {
    return byLabel
  }
  const byNumber = list.filter(item => item.po_number === text)
  return byNumber.length === 1 ? byNumber[0] : null
}
